export const isMobile = window.innerHeight < 844 || window.innerWidth < 390;
